/**
 * Created by kachavas on 6/24/16.
 */
angular
  .module('ui-ng-ax')
  .directive('phxAxContainFocus', function phxFocusDirective(phxAxContainFocusServant) {
    return {
      restrict: 'A',
      scope:false,
      link: function(scope, element) {
        phxAxContainFocusServant.trapFocus(element);
      }
    };
  });


// WEBPACK FOOTER //
// phx_contain_focus.js